import React from "react";
import Menu from "./Menu";

function Notfound() {
    return (
        <div
            style={{
                display: "flex",
            }}
        >

            {/* RIGHT CONTENT */}
            <div
                style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "20px"
                }}
            >
                <div
                    style={{
                        padding: "50px",
                        borderRadius: "15px",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "90px",
                            margin: "0",
                            fontWeight: "700",
                            color: "#0e7d72"
                        }}
                    >
                        404
                    </h1>

                    <h2
                        style={{
                            fontSize: "28px",
                            marginTop: "10px",
                            fontWeight: "600",
                            color: "#333"
                        }}
                    >
                        Page Not Found
                    </h2>

                    <p
                        style={{
                            fontSize: "16px",
                            marginTop: "10px",
                            color: "#666",
                            lineHeight: "1.6"
                        }}
                    >
                        The page you are looking for doesn’t exist or was moved.
                    </p>

                    {/* BACK TO HOME BUTTON */}
                    <a
                        href="/home"
                        style={{
                            display: "inline-block",
                            marginTop: "25px",
                            padding: "12px 28px",
                            background: "linear-gradient(90deg, #099b91, #2a0845)",
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: "600",
                            borderRadius: "30px",
                            textDecoration: "none",
                            boxShadow: "0 5px 15px rgba(100,65,165,0.3)",
                            transition: "0.3s"
                        }}
                        onMouseOver={(e) =>
                            (e.target.style.transform = "translateY(-3px)")
                        }
                        onMouseOut={(e) =>
                            (e.target.style.transform = "translateY(0px)")
                        }
                    >
                        ⬅ Back to Home
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Notfound;
